import https from '@sg/utils/httpC';

// Globalpedia APIs
export const getPipelineCalendarData = (payload: any): Promise<any> =>
  https({
    url: '/api/v1/globalpedia_pc/studio_overall/calendar/list',
    method: 'post',
    data: payload,
    rawData: true,
  });

export const getStudioCalendarData = (payload: any): Promise<any> =>
  https({
    url: '/api/v1/globalpedia_pc/mgmt/scheduleV2',
    method: 'post',
    data: payload,
    rawData: true,
  });

export const getStudioList = (params: any): Promise<any> =>
  https({
    // url: '/api/v1/globalpedia_pc/studio_overview/information_glanceV2', (old api which has high latency)
    url: '/api/v1/globalpedia_pc/mgmt/studio_management/studios',
    method: 'get',
    data: params,
  });

export const getLiveTitleSummary = (params: any): Promise<any> =>
  https({
    url: '/api/v1/globalpedia_pc/studio_monthly_report/mgmt/live_title/summary',
    method: 'post',
    data: params,
  });

export const getInDevProjectList = (params: any): Promise<any> =>
  https({
    url: '/api/v1/globalpedia_pc/mgmt/studio_management/projects',
    method: 'get',
    data: params,
  });

export const getInDevProjectDataAnalytics = (params: any): Promise<any> =>
  https({
    url: '/api/v1/mgmt_pc/studio/in_dev/data_analytics/list',
    method: 'post',
    data: params,
  });

// In dev timeline project (to be removed later)
// export const getGRManagementTimelineByID = (params: { id: number | string }): Promise<any> => https({
//   url: `/api/v1/globalpedia_pc/project/detail_game_info?id=${params.id}`,
//   method: 'get',
// });

export const getStudioPipelineCalendar = (params: any): Promise<any> =>
  https({
    url: '/api/v1/mgmt_pc/studio/pipeline-calendar',
    method: 'post',
    data: params,
  });

export const getStudioPipelineCalendarStudios = (params: any): Promise<any> =>
  https({
    url: '/api/v1/mgmt_pc/studio/studios/pipeline-calendar',
    method: 'post',
    data: params,
  });

export const updateStudioPipelineCalendar = (params: any): Promise<any> =>
  https({
    url: '/api/v1/mgmt_pc/studio/pipeline-calendar/update',
    method: 'post',
    data: params,
  });

export const getStudioLiveTitleOverview = (params: any): Promise<any> =>
  https({
    url: '/api/v1/mgmt_pc/studio/live-title/overview',
    method: 'post',
    data: params,
  });

export const updateStudioLiveTitleOverview = (params: any): Promise<any> =>
  https({
    url: '/api/v1/mgmt_pc/studio/live-title/overview/edit',
    method: 'post',
    data: params,
  });

export const getStudioInDevOverview = (params: any): Promise<any> =>
  https({
    url: '/api/v1/mgmt_pc/studio/in_dev/overview',
    method: 'post',
    data: params,
  });

export const updateStudioInDevOverview = (params: any): Promise<any> =>
  https({
    url: '/api/v1/mgmt_pc/studio/in_dev/overview/edit',
    method: 'post',
    data: params,
  });
